/* eslint-disable no-debugger */
import React from 'react';
import { DataTable } from 'primereact/components/datatable/DataTable';
import { Column } from 'primereact/components/column/Column';
import { Panel } from 'primereact/components/panel/Panel';
import { Button } from 'primereact/components/button/Button';
import { Dialog } from 'primereact/components/dialog/Dialog';

import config from '../../../../../../config/config';
import { getData } from './data';
import DisplayBlockService from '../../../../../../utils/services/displayBlock';
import GlobalVar from '../../../../../shared/globalVar/GlobalVar';
import FormElement from '../../../../../shared/form/FormElement';

const _fixedEditKey = 's0rmet@edit';

class CodeBlockPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      campaignVersionId: this.props.campaignVersionId,
      data: this.props.data,
      dialogConfirmationVisible: false,
      selectedDisplayBlock: '',
      renderVersion: 1,
      deletePassword: ''
    };
  }

    visualizeAction = (rowData) => (
      <span
        className="fa fa-eye"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          window.open(
            `${config.API.BASEURL}/codeBlock/previewHtml/${rowData.codeBlockId}`,
            'newwindow',
            'width=800,height=500'
          );
        }}
      />
    );

    editAction = (rowData) => (
      <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', gap: '10px', margin: '15px'}}>
        <div>
          <Button
            type="button"
            icon="fa fa-trash"
            style={{color: '#485465', backgroundColor: 'transparent', padding: 0, margin: 0}}
            onClick={(e) => { this.showConfirmationDialog(e,rowData); }}> </Button>
        </div>
        <div style={{ display: (rowData.type == 'lightbox' && this.state.renderVersion == '2') ? 'none' : 'flex', placeContent: 'center', justifyContent: 'center', flexDirection: 'column'}}>
          <span
            className="fa fa-cog"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              window.open(
                `${config.URL.BASEFRONT}/admin/codeBlock/${rowData.codeBlockId}`,
                '_blank'
              );
            }}
          />
        </div>
      </div>
    );

    onLazyLoad = (event) => {
      if (event) {
        this.state.first = isNaN(event.first) ? 0 : event.first;
      }

      this.setState({ loading: true });
      getData(this.state.campaignVersionId).then((response) => {
        this.setState({
          list: response,
          rewardPoolName: response.rewardPoolName,
          loading: false,
        });
      });
    };

    closeConfirmationPopup = () => {
      var reset = {
        dialogConfirmationVisible: false,
        selectedDisplayBlock: '' 
      };
  
      this.setState(reset);
    }

    renderConfirmationDialog = () => {
      var headerName = `Confirmation`;
  
      return (
  
        <Dialog
          header={headerName}
          footer={this.dialogConfirmationFooter()}
          visible={this.state.dialogConfirmationVisible}
          width="550px"
          modal={true}
          resizable={true}
          responsive={true}
          onHide={this.closeConfirmationPopup}
        >
          <div className="content-section implementation">
            <span>Are you sure you want to delete this code block?</span>
          </div>
  
        </Dialog>
      );
    };

    deleteDisplayBlockById = (id) => {
      DisplayBlockService.deleteDisplayBlockById(id)
        .then(() => {
          this.onLazyLoad(null);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.closeConfirmationPopup();
          this.setState({deletePassword: null });
        });
    
    }

    dialogConfirmationFooter = () => {
      return <div style={{ display: 'flex', placeContent: 'center', width: '100%', gap: '20px' }} className="ui-dialog-buttonpanel p-clearfix">
        <FormElement
          placeholder="Security password"
          name="deletePassword"
          type="password"
          onChange={(e) => {
            
            this.setState({deletePassword: e.target.value });}}
          value={this.state.deletePassword}
          id="deletePassword"
        />
        <div style={{ display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
          <Button label="Delete" disabled={this.state.deletePassword != _fixedEditKey} onClick={(e) => this.deleteDisplayBlockById(this.state.selectedDisplayBlock)} />
        </div>
        <div style={{ display: 'flex', placeContent: 'center', flexDirection: 'column' }}>
          <Button label="Cancel" onClick={this.closeConfirmationPopup} />
        </div>
      </div>;
    };

    showConfirmationDialog = (e,rowData) => {
      
      this.setState({
        dialogConfirmationVisible: true,
        selectedDisplayBlock: rowData._id
      });
    };

    componentDidMount = () => this.onLazyLoad();

    render = () => (
      <div>
        <Panel header={<span style={{ color: '#485465' }}>Code Blocks</span>}>
          <DataTable
            value={this.state.list}
            responsive={true}
            onLazyLoad
            sortMode="multiple"
            lazy={true}
            onLazyLoad={this.onLazyLoad}
            loading={this.state.loading}
            ref={(el) => (this.dt = el)}
            first={this.state.first}
          >
            <Column field="type" header="Type" />
            <Column
              body={(e) => this.visualizeAction(e)}
              style={{ textAlign: 'center', width: '40px' }}
            />
            <Column
              body={(e) => this.editAction(e)}
              style={{ textAlign: 'center', width: '70px' }}
            />
          </DataTable>
          <hr />
          
          <div style={{ display: 'none'}}>            
            <GlobalVar context='CAMPAIGN_VERSION.LIGHTBOX' objectId={this.props.campaignVersionId} modalMode={false} 
              fetchedValues={(gvs) => { 
                let renderVersion = 1;
                const renderVersionObj = gvs.find((gv) => gv.settingKey == 'RENDER_VERSION');

                if(renderVersionObj && renderVersionObj.value){
                  renderVersion = renderVersionObj.value[0];
                }
                this.setState({
                  renderVersion
                });
              }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <a
              href={`${config.URL.NEWFRONT}/asset/search?cpv_id=${this.props.campaignVersionId}`}
              target="_blank"
            >
                      Global lightbox
            </a>
            <a
              href={`/lightbox/test.html?env=${config.ENVIRONMENT}&testMode=true&clientId=${this.props.data.clientId}&campaignVersionId=${this.props.campaignVersionId}`}
              target="_blank"
            >
              <i
                class="fa fa-external-link-square"
                aria-hidden="true"
              ></i>
            </a>
          </div>
        </Panel>
        {this.renderConfirmationDialog()}
      </div>
    );
}

export default CodeBlockPanel;
